export default __webpack_public_path__ + "static/media/1200px-Colosseo_2020 .99963643.jpg";